import { useMutation } from "@tanstack/react-query";
import { Button, Flex, Spin, Typography } from "antd";
import { bindCompanies } from "entities/companies";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";
import styles from "./index.module.scss";

export const BindCompaniesView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = localStorage.getItem("bind-companies-ref");

  const { mutate, isPending, isError, isSuccess, data, error } = useMutation({
    mutationFn: bindCompanies,
  });

  useEffect(() => {
    if (ref) {
      mutate(ref);
    } else {
      const pathname = localStorage.getItem("pathname");
      if (pathname) {
        navigate(pathname);
      } else {
        navigate(ROUTES.MAIN);
      }
    }
  }, [ref, mutate, navigate]);

  const goToMainPage = () => {
    localStorage.removeItem("bind-companies-ref");
    navigate(ROUTES.MAIN);
  };

  if (isPending) {
    return (
      <div className={styles.wrapperLoader}>
        <Spin />
      </div>
    );
  }

  if (isError) {
    return (
      <Flex vertical gap="large">
        <div>
          <Typography.Title level={5}>
            {t("bind_companies.error_title")}
          </Typography.Title>
          <Typography.Text style={{ display: "block" }} type="danger">
            {(error as any).response?.data?.message}
          </Typography.Text>
        </div>

        <Button block type="primary" onClick={() => ref && mutate(ref)}>
          {t("bind_companies.retry")}
        </Button>
        <Button block onClick={goToMainPage}>
          {t("bind_companies.go_to_main")}
        </Button>
      </Flex>
    );
  }

  if (isSuccess) {
    return (
      <Flex vertical gap="large">
        <div>
          <Typography.Title level={5}>
            {t("bind_companies.success_title")}
          </Typography.Title>
          <Typography.Text style={{ display: "block" }}>
            {data?.message}
          </Typography.Text>
        </div>

        <Button block type="primary" onClick={goToMainPage}>
          {t("bind_companies.go_to_main")}
        </Button>
      </Flex>
    );
  }

  return null;
};
